/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum CustomerProfileSearchField {
  NAME="NAME",
ADDRESS="ADDRESS"
}

/**
* CustomerProfileSearchField
 *
 * Customer fields a search can be restricted to
*/
export const CustomerProfileSearchFieldEnumType = types.enumeration("CustomerProfileSearchField", [
        "NAME",
  "ADDRESS",
      ])
